import { lazy } from 'react';

// ----------------------------------------------------------------------

export const LoginPage = lazy(() => import('src/pages/auth/login'));
export const ForgotPasswordPage = lazy(() => import('src/pages/auth/forgot-password'));
export const ResetPasswordPage = lazy(() => import('src/pages/auth/reset-password'));
export const AcceptInvitationPage = lazy(() => import('src/pages/auth/accept-invitation'));
export const PocSignupPage = lazy(() => import('src/pages/auth/poc-signup'));
export const Page500 = lazy(() => import('src/pages/500'));
export const Page403 = lazy(() => import('src/pages/403'));
export const Page404 = lazy(() => import('src/pages/404'));
